// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f8364cc0","239":"c5cbbf22","656":"d1c6f9fc","667":"3fd04d4f","801":"e8d9c544"}[chunkId] + ".chunk.js";
};